import React from 'react';
import { Plane, TrendingUp, Gift } from 'lucide-react';

export const HowItWorks: React.FC = () => {
  return (
    <section id="how-it-works" className="pt-24 pb-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 uppercase tracking-wide mb-4">
            Kako funkcioniše <span className="text-go2-pink">Go2 Legends</span>
          </h2>
          <div className="w-24 h-1 bg-go2-yellow mx-auto mb-6"></div>
          <p className="text-xl text-gray-500 max-w-2xl mx-auto">
            Jednostavni koraci do uštede i nagrada. Putuj, sakupljaj i uživaj.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Card 1 */}
          <div className="bg-white rounded-2xl p-8 border border-gray-100 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-2 text-center group">
            <div className="w-20 h-20 bg-brand-50 rounded-full flex items-center justify-center mb-8 mx-auto group-hover:bg-go2-pink transition-colors">
              <Plane className="w-10 h-10 text-go2-pink group-hover:text-white transition-colors" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 uppercase">1. Putuj sa Go2</h3>
            <p className="text-gray-500 leading-relaxed">
              Rezerviši bilo koje putovanje sa Go2 i automatski postaješ član. Nema dodatne prijave.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-2xl p-8 border border-gray-100 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-2 text-center group">
            <div className="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mb-8 mx-auto group-hover:bg-go2-blue transition-colors">
              <TrendingUp className="w-10 h-10 text-go2-blue group-hover:text-white transition-colors" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 uppercase">2. Sakupljaj bodove</h3>
            <p className="text-gray-500 leading-relaxed">
              Za svaki potrošen 1 EUR, dobijaš 1 bod. Dostigni više nivoe na osnovu ukupne potrošnje u poslednja 24 meseca.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-2xl p-8 border border-gray-100 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-2 text-center group">
            <div className="w-20 h-20 bg-yellow-50 rounded-full flex items-center justify-center mb-8 mx-auto group-hover:bg-go2-yellow transition-colors">
              <Gift className="w-10 h-10 text-yellow-600 group-hover:text-white transition-colors" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 uppercase">3. Otključaj nagrade</h3>
            <p className="text-gray-500 leading-relaxed">
              Zameni bodove za popuste, ostvari do 40% popusta, otključaj dostignuća i specijalne pogodnosti.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
